import { useAuth0 } from '@auth0/auth0-react';
import Search from '@mui/icons-material/Search';

import { CampaignRecord, getCampaigns } from '@/apis/campaigns';
import { AutocompleteResult, TemplatePlaceholder } from '@/types';
import TemplateCapableFetchAutocomplete, {
  TemplateCapableFetchAutocompleteChangeReason,
} from '@/components/TemplateCapableFetchAutocomplete';
import { SearchTemplatePageContext } from '@/context/SearchTemplateContext';
import { useContext } from 'react';
import { labelSorting } from '@/util/labelSorting';

type EventCampaignsProps = {
  onChange: (
    newValue: AutocompleteResult[] | TemplatePlaceholder,
    reason: TemplateCapableFetchAutocompleteChangeReason
  ) => void;
  value: AutocompleteResult[] | TemplatePlaceholder;
  isAdvancedSearch?: boolean;
  error?: boolean;
};

const EventCampaigns = ({
  value = [] as AutocompleteResult[] | TemplatePlaceholder,
  onChange = () => {},
  isAdvancedSearch,
  error = false,
}: EventCampaignsProps) => {
  const { getAccessTokenSilently } = useAuth0();
  const inSearchTemplate = useContext(SearchTemplatePageContext);
  const lookup = async (lookupValue: string) => {
    const token = await getAccessTokenSilently();
    const campaigns = await getCampaigns(token, lookupValue);
    return campaigns
      .map((x: CampaignRecord) => {
        return { id: x.id, label: x.title };
      })
      .sort(labelSorting);
  };

  return (
    <TemplateCapableFetchAutocomplete
      sx={isAdvancedSearch ? { width: '45ch' } : {}}
      lookup={lookup}
      minLength={3}
      label="Held by campaign(s) (optional)"
      value={value}
      onChange={onChange}
      data-testid="getfiltercampaigns"
      loadingText="Looking for campaigns..."
      noOptionsText="No campaigns found"
      popupIcon={<Search />}
      disableIconFlip
      isOnTemplatePage={inSearchTemplate}
      templateBuilderDisplayName="Event attendance filter: Campaign(s)"
      error={error}
    />
  );
};

export default EventCampaigns;
